import { render, staticRenderFns } from "./paperTemList.vue?vue&type=template&id=54b39bd2&scoped=true&"
import script from "./paperTemList.vue?vue&type=script&lang=js&"
export * from "./paperTemList.vue?vue&type=script&lang=js&"
import style0 from "./paperTemList.vue?vue&type=style&index=0&id=54b39bd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b39bd2",
  null
  
)

export default component.exports